import { createFileRoute } from '@tanstack/react-router';
import { schemaGeneralEventApiResponse } from 'cpool-schemas';
import { z } from 'zod';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { fetcher } from '~/queryUtils/useQuery';

export const Route = createFileRoute('/_app/leads_/details/$leadId/history/$categoryId')({
    beforeLoad: ({ location }) => authoriseUser(Object.values(ROLES), location),
    loader: async ({ context, params }) => {
        const { categoryId, leadId } = params;
        const aggregateIds = JSON.stringify([leadId]);
        await context.queryClient.ensureQueryData({
            meta: {
                queryUrl: `/events?aggregateIds=${aggregateIds}&category=${categoryId}&appendCategory=${
                    categoryId === 'all'
                }`,
                schema: z.array(schemaGeneralEventApiResponse.passthrough()),
            },
            queryFn: fetcher,
            queryKey: ['history-events', { categoryId, leadId }],
        });
    },
});
